import React from 'react';

class Navbar extends React.Component {
    state = {}
    render() {
        return (
            <nav className="navbar navbar-expand-lg bg-info">
                <div className="container-fluid">
                    <h3><a className="navbar-brand text-white" href="#">
                        ShopyKart
                    </a></h3>
                </div>
            </nav>);
    }
}

export default Navbar;